module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('h5', [_vm._v("Customer details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._m(0), _vm._v(" "), (_vm.getNamePrefixList) ? _c('div', {
    staticClass: "d-flex mb-3"
  }, [_c('v-select', {
    staticClass: "glued-right",
    attrs: {
      "options": _vm.getNamePrefixList,
      "label": "description",
      "placeholder": "- Select title -"
    },
    on: {
      "input": _vm.updatePrefix
    },
    model: {
      value: (_vm.selectedPrefix),
      callback: function($$v) {
        _vm.selectedPrefix = $$v
      },
      expression: "selectedPrefix"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.customer.name),
      expression: "form.customer.name"
    }],
    staticClass: "full glued-left",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.customer.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.customer, "name", $event.target.value)
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.customer.surname),
      expression: "form.customer.surname"
    }],
    staticClass: "full",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.customer.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.customer, "surname", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.getLanguages) ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Language")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getLanguages,
      "label": "name",
      "placeholder": "- Select language -"
    },
    on: {
      "input": _vm.updateLanguage
    },
    model: {
      value: (_vm.selectedLanguage),
      callback: function($$v) {
        _vm.selectedLanguage = $$v
      },
      expression: "selectedLanguage"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.getCountries) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Nationality")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getCountries,
      "label": "name",
      "placeholder": "- Select country -"
    },
    on: {
      "input": _vm.updateCountry
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "d-flex form-group"
  }, [_c('div', {
    staticClass: "glued-right country-code"
  }, [_vm._v(_vm._s(_vm.form.customer.countryDial))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.customer.phone),
      expression: "form.customer.phone"
    }],
    staticClass: "glued-left",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.customer.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.customer, "phone", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Accomodation")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.customer.accomodation),
      expression: "form.customer.accomodation"
    }],
    staticClass: "full",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.customer.accomodation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.customer, "accomodation", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Room")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.customer.room),
      expression: "form.customer.room"
    }],
    staticClass: "full",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.customer.room)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.customer, "room", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.customer.email),
      expression: "form.customer.email"
    }],
    staticClass: "full",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.form.customer.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.customer, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "mt-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.form.customer.sendEmail),
      callback: function($$v) {
        _vm.$set(_vm.form.customer, "sendEmail", $$v)
      },
      expression: "form.customer.sendEmail"
    }
  }, [_vm._v("\n                    Send a copy to this email\n                ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    staticClass: "ico-wheelchair color-1 largest"
  }), _vm._v(" "), _c('checkbox', {
    model: {
      value: (_vm.form.customer.isSpecialAssistanceRequired),
      callback: function($$v) {
        _vm.$set(_vm.form.customer, "isSpecialAssistanceRequired", $$v)
      },
      expression: "form.customer.isSpecialAssistanceRequired"
    }
  }, [_vm._v("For special assistance, tick this box.")])], 1), _vm._v(" "), (_vm.form.customer.isSpecialAssistanceRequired) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.customer.specialAssistanceNote),
      expression: "form.customer.specialAssistanceNote"
    }],
    attrs: {
      "placeholder": "Type your needs, so we can provide you the best assistance ..."
    },
    domProps: {
      "value": (_vm.form.customer.specialAssistanceNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.customer, "specialAssistanceNote", $event.target.value)
      }
    }
  })]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                First Name "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                Surname "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                Phone Number "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("\n                Email "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7f726680", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f726680"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Customer.vue
// module id = 2184
// module chunks = 0